import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';

import { Resume } from '../../interfaces/interfaces';
import { ResumeService } from '../../services/resume.service';
import { AuthService } from '../../../core/services/auth.service';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
  selector: 'app-add-summary',
  templateUrl: './add-summary.component.html',
  styleUrls: ['./add-summary.component.css']
})
export class AddSummaryComponent implements OnInit {
  public resume: Resume = {} as Resume;
  public valueStack: any;
  public descs = [
    '<p>I am quick learner and hope to achieve my goals through sheer hard work. I have a thirst for knowledge and like to develop my skills that can take me to a more advanced level.</p>',
    '<p>Internet executive with background in product management, business development, sales, and business operations. Experience in building online businesses and products for consumers and enterprises.</p>',
    '<p>I like to solve problems. Throughout my career, I have been driven by my intellectual curiosity to find answers to the most pressing questions.</p>',
    '<p>My intellectual curiosity drives me to be a lifelong learner. I am currently earning my MBA from [college name], with a graduate certificate in strategy and management consulting.</p>',
    '<p>I am a hard working, honest individual. I am a good timekeeper, always willing to learn new skills.</p>',
    '<p>I am friendly, helpful and polite, have a good sense of humour. I am able to work independently in busy environments and also within a team setting. I am outgoing and tactful, and able to listen effectively when solving problems.</p>',
    '<p>I am a punctual and motivated individual who is able to work in a busy environment and produce high standards of work.</p>',
    '<p>I am an excellent team worker and am able to take instructions from all levels and build up good working relationships with all colleagues.</p>',
    '<p>I am flexible, reliable and possess excellent time keeping skills.</p>',
    '<p>I am an enthusiastic, self-motivated, reliable, responsible and hard working person.</p>',
    '<p>I am a mature team worker and adaptable to all challenging situations. I am able to work well both in a team environment as well as using own initiative. I am able to work well under pressure and adhere to strict deadlines.</p>',
    '<p>I am a dedicated, organized and methodical individual. I have good interpersonal skills, am an excellent team worker and am keen and very willing to learn and develop new skills.</p>',
    '<p>I am reliable and dependable and often seek new responsibilities within a wide range of employment areas. I have an active and dynamic approach to work and getting things done. I am determined and decisive. I identify and develop opportunities.</p>',
    '<p>I’m a nice fun and friendly person, I’m honest and punctual, I work well in a team but also on my own as I like to set myself goals which I will achieve, I have good listening and communication skills.</p>',
    '<p>I have a creative mind and am always up for new challenges. I am well organized and always plan ahead to make sure I manage my time well.</p>'
  ];
  constructor(
    private router: Router,
    private authService: AuthService,
    private resumeService: ResumeService,
    private localStorageService: LocalStorageService,
    public utilService: UtilService
  ) {
    const resume_id = this.localStorageService.get('resume_id');
    if (resume_id) {
      this.resumeService.getResumeById(resume_id).subscribe(res => {
        this.valueStack = res;
        this.resume = res.Resume;
      });
    }
  }
  save() {
    this.resumeService.editResume(this.resume).subscribe(res => {
      this.resume = res.resume;
      // const theme_id = this.localStorageService.get('theme_id') as string || 1;
      this.router.navigate(['/resume/edu']);
    });
  }
  append(model, html) {
    model.professional_summary += html;
  }

  ngOnInit() {
  }
  goToTheme () {
    const theme_id = this.localStorageService.get('theme_id') as string || 1;
    this.router.navigate(['/themes/' + theme_id]);
  }

}
